export const AppConfigs = {
  apiBaseUrl: "https://api.s1gm4.co.uk/api/",
  // apiBaseUrl: "https://localhost:44362/api/",
  // apiBaseUrl: "http://172.167.121.200:9000/api/"
  // apiBaseUrl: "http://172.167.121.200:9090/api/"
  // apiBaseUrl: "http://13.71.29.213:9090/api/"
  // apiBaseUrl:"https://munarayan.duckdns.org/api/"
  // apiBaseUrl: "https://iconnectdev.uksouth.cloudapp.azure.com/api/"
};
